module.exports = __webpack_public_path__ + "account/assets/participant.ec54450d.svg";